import React from 'react'

export default function Footer(){
  return (
    <footer>
      {/* Main Footer */}
      <div className="container-fluid py-5" style={{background: 'linear-gradient(135deg, #5d4037 0%, #3e2723 100%)', color: 'white'}}>
        <div className="container">
          <div className="row g-5">
            {/* Company Info */}
            <div className="col-lg-3 col-md-6">
              <div className="mb-4">
                <a href="/" className="d-block mb-3">
                  <img src="/img/updatedlogo.jpeg" height="140px" width="220px" alt="Lakulish Pharmaceuticals Logo" className="img-fluid" />
                </a>
                <p className="text-light mb-3" style={{fontSize: '0.95rem', lineHeight: '1.6'}}>
                  Leading pharmaceutical company dedicated to healthcare excellence through innovation, quality, and global partnerships since 2015.
                </p>
              </div>

              {/* Certifications */}
              {/* <div className="mb-3">
                <h6 className="text-uppercase font-weight-bold mb-3" style={{color: '#d7ccc8'}}>Certifications</h6>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge badge-light px-2 py-1">WHO-GMP</span>
                  <span className="badge badge-light px-2 py-1">ISO 9001:2015</span>
                 </div>
              </div> */}
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="mb-4">
                <a href="/" className="d-block mb-3">
                  <img src="/img/duns.png" height="140px" width="220px" alt="D-U-N-S Registered" className="img-fluid" />
                </a>
                <p className="text-light mb-3" style={{fontSize: '0.95rem', lineHeight: '1.6'}}>
                D-U-N-S No: 771937357                 
                </p>
                <p className="text-light mb-3" style={{fontSize: '0.95rem', lineHeight: '1.6'}}>

                GST No: 24BSCPP5056J1ZL
                </p>
              </div>

              {/* Certifications */}
              {/* <div className="mb-3">
                <h6 className="text-uppercase font-weight-bold mb-3" style={{color: '#d7ccc8'}}>Certifications</h6>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge badge-light px-2 py-1">WHO-GMP</span>
                  <span className="badge badge-light px-2 py-1">ISO 9001:2015</span>
                 </div>
              </div> */}
            </div>
            {/* Quick Links */}
            <div className="col-lg-2 col-md-6">
              <h5 className="text-uppercase font-weight-bold mb-4" style={{color: '#d7ccc8'}}>Quick Links</h5>
              <ul className="list-unstyled">
                <li className="mb-2"><a href="/" className="text-light text-decoration-none"><i className="fas fa-chevron-right mr-2" style={{fontSize: '0.8rem'}}></i>Home</a></li>
                <li className="mb-2"><a href="/about" className="text-light text-decoration-none"><i className="fas fa-chevron-right mr-2" style={{fontSize: '0.8rem'}}></i>About Us</a></li>
                <li className="mb-2"><a href="/research" className="text-light text-decoration-none"><i className="fas fa-chevron-right mr-2" style={{fontSize: '0.8rem'}}></i>R&D / Technical</a></li>
                <li className="mb-2"><a href="/infrastructure" className="text-light text-decoration-none"><i className="fas fa-chevron-right mr-2" style={{fontSize: '0.8rem'}}></i>Infrastructure</a></li>
                <li className="mb-2"><a href="/products" className="text-light text-decoration-none"><i className="fas fa-chevron-right mr-2" style={{fontSize: '0.8rem'}}></i>Products</a></li>
                <li className="mb-0"><a href="/contact" className="text-light text-decoration-none"><i className="fas fa-chevron-right mr-2" style={{fontSize: '0.8rem'}}></i>Contact Us</a></li>
              </ul>
            </div>



            {/* Contact Info */}
            <div className="col-lg-4 col-md-6">
              <div className="row">
                <div className="col-6">
                  <a href="mailto:lakulishpharma@gmail.com" className="text-decoration-none">
                    <h5 className="text-uppercase font-weight-bold mb-4" style={{color: '#d7ccc8'}}>Get In Touch</h5>
                  </a>
                  <div className="mb-3">
                    <p className="mb-2">
                      <i className="fas fa-map-marker-alt mr-3" style={{color: '#d7ccc8'}}></i>
                      <a href="https://www.google.com/maps?q=C-315, Siddharth Annexe 3, Vemali, Vadodara-391740, Gujarat, India"
                         className="text-light text-decoration-none" style={{fontSize: '0.9rem'}}>
                        C-315, Siddharth Annexe 3<br />
                        Vemali, Vadodara-391740<br />
                        Gujarat, India
                      </a>
                    </p>
                    <p className="mb-2">
                      <i className="fas fa-phone-alt mr-3" style={{color: '#d7ccc8'}}></i>
                      <a href="tel:+91-9974525039" className="text-light text-decoration-none">+91 9974525039</a>
                    </p>

                    <p className="mb-2">
                      <i className="fas fa-envelope mr-3" style={{color: '#d7ccc8'}}></i>
                      <a href="mailto:lakulishpharma@gmail.com" className="text-light text-decoration-none">lakulishpharma@gmail.com</a>
                    </p>

                  </div>
                </div>

                <div className="col-6">
                  <h5 className="text-uppercase font-weight-bold mb-4" style={{color: '#d7ccc8'}}>Connect With Us</h5>

                  {/* Social Media */}
                  <div className="mb-4">
                    <a href="mailto:lakulishpharma@gmail.com"
                       className="btn btn-outline-light btn-sm mr-2 mb-2" title="Gmail">
                      <i className="fas fa-envelope"></i> Gmail
                    </a>

                    <a href="https://wa.me/9974525039"
                       className="btn btn-outline-light btn-sm mr-2 mb-2" title="Whatsapp">
                      <i className="fab fa-whatsapp"></i> WhatsApp
                    </a>


                    <a href="https://www.linkedin.com/in/p-c-patel-7335311a0?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                       className="btn btn-outline-light btn-sm mr-2 mb-2" title="LinkedIn">
                      <i className="fab fa-linkedin-in"></i> LinkedIn
                    </a>
                    {/* <a href="skype:live:.cid.8d4c1c88a6ae4f6b?chat"
                       className="btn btn-outline-light btn-sm mr-2 mb-2" title="Skype">
                      <i className="fab fa-skype"></i> Skype
                    </a> */}

                  </div>

                  {/* Newsletter */}
                  {/* <div>
                    <h6 className="text-uppercase font-weight-bold mb-3" style={{color: '#d7ccc8', fontSize: '0.9rem'}}>Stay Updated</h6>
                    <p className="text-light mb-2" style={{fontSize: '0.85rem'}}>
                      Subscribe for pharmaceutical industry updates and company news.
                    </p>
                    <div className="input-group">
                      <input type="email" className="form-control form-control-sm" placeholder="Your email" style={{backgroundColor: 'rgba(255,255,255,0.1)', border: '1px solid #d7ccc8', color: 'white'}} />
                      <div className="input-group-append">
                        <button  type="button" style={{border: '1px solid #d7ccc8'}}>
                          <i className="fas fa-paper-plane"></i>
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="py-4" style={{backgroundColor: '#3e2723', borderTop: '1px solid #5d4037'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-left">
              <p className="mb-0 text-light" style={{fontSize: '0.9rem'}}>
                &copy; 2015 <strong>Lakulish Pharmaceuticals</strong>. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <a href="#" className="btn btn-lg position-fixed" style={{bottom: '20px', right: '20px', backgroundColor: '#5d4037', borderColor: '#5d4037', color: 'white', borderRadius: '50%', width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 8px rgba(0,0,0,0.3)'}}>
        <i className="fas fa-arrow-up"></i>
      </a>
    </footer>
  )
}
